





































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryHouseByCode, QueryUserList } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'

@Component({
  components: {
    VTable,
  },
})
export default class HouseDescDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  private houseInfo: any = {}

  @Emit('close')
  private close() {
    this.show = false
  }
  private show = false
  private tableData = []

  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: '_index', type: 'index' },
    { title: '用户编号', param: 'mobilePhone' },
    { title: '用户手机号', param: 'userNo' },
    { title: '用户姓名', param: 'nickname' },
  ]
  public async open(houseCode: string) {
    this.show = true
    this.houseInfo = {}
    this.tableData = []
    if (houseCode) {
      const result = await QueryHouseByCode({ houseCode })
      this.houseInfo = result || {}
      const userReuslt = await QueryUserList({ limit: 100, houseCode })
      this.tableData = (userReuslt && userReuslt.list) ? userReuslt.list : []
    }
  }

  public async save() {
    this.close()
  }
}
